import { render, staticRenderFns } from "./SystemAddSeller.vue?vue&type=template&id=a226f110&scoped=true"
import script from "./SystemAddSeller.vue?vue&type=script&lang=js"
export * from "./SystemAddSeller.vue?vue&type=script&lang=js"
import style0 from "./SystemAddSeller.vue?vue&type=style&index=0&id=a226f110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226f110",
  null
  
)

export default component.exports